import React, { FormEventHandler, useMemo, useState } from 'react';
import {
  Error,
  errorBgColorTailwind,
  Errors,
} from '../components/commons/Error';
import {
  TargetAmountValidateError,
  targetAmountErrorToString,
} from 'components/features/target-achievement-support/utils/validate';
import { TargetAmount } from 'components/features/target-achievement-support/utils/type';
import { toNumber } from 'components/features/target-achievement-support/utils/utils';

export const useTargetAmountForm = ({
  amountErrors,
  initialTargetAmount,
}: {
  amountErrors: TargetAmountValidateError[];
  initialTargetAmount: TargetAmount;
}): {
  TargetAmountForm: React.ReactElement;
  isAmountError: boolean;
  targetAmount: number | null;
} => {
  const isAmountError = !!amountErrors.length;
  const [targetAmount, setTargetAmount] = useState<
    { tag: 'Just'; value: number } | { tag: 'Nothing' }
  >(
    initialTargetAmount !== undefined
      ? { tag: 'Just', value: initialTargetAmount }
      : { tag: 'Just', value: 0 }
  );
  const onInputTargetAmount: FormEventHandler<HTMLInputElement> = event =>
    ((n): void => {
      if (!n) {
        setTargetAmount({ tag: 'Nothing' });
        return;
      }
      const num = toNumber(n);
      setTargetAmount(
        num === null ? { tag: 'Nothing' } : { tag: 'Just', value: num * 10000 }
      );
    })(event.currentTarget.value);
  const TargetAmountForm = useMemo((): React.ReactElement => {
    return (
      <>
        <div>
          <div className="flex flex-row items-end">
            <input
              {...{
                value:
                  targetAmount.tag === 'Just'
                    ? Math.floor(targetAmount.value / 10000)
                    : '',
                onChange: onInputTargetAmount,
              }}
              className={`h-10 rounded-lg w-full border ${
                isAmountError ? `bg-${errorBgColorTailwind}` : ''
              } border-bluegray-400 px-4`}
              type="number"
              placeholder="金額を入力"
            />
            <div className="text-bluegray-700 text-xs whitespace-no-wrap ml-2">
              万円
            </div>
          </div>
          {isAmountError && (
            <Errors className="mt-1">
              {amountErrors.map(e => (
                <Error
                  {...{
                    error: e,
                    errorToString: targetAmountErrorToString,
                  }}
                  key={e}
                />
              ))}
            </Errors>
          )}
        </div>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amountErrors, targetAmount]);
  return {
    TargetAmountForm,
    isAmountError,
    targetAmount: targetAmount.tag === 'Just' ? targetAmount.value : null,
  };
};
